import { useMediaQuery } from 'react-responsive';
import { useState, useEffect } from 'react';

export function useDevice() {
  // Define state for mounted status
  const [isMounted, setIsMounted] = useState(false);
  
  // Always call hooks unconditionally for consistent order
  const mqMobile = useMediaQuery({ maxWidth: 767 });
  const mqTablet = useMediaQuery({ minWidth: 768, maxWidth: 1023 });
  const mqDesktop = useMediaQuery({ minWidth: 1024 });
  const mqLargeDesktop = useMediaQuery({ minWidth: 1440 });
  
  useEffect(() => {
    setIsMounted(true);
  }, []);
  
  // Only use the media query results when mounted
  const isMobile = isMounted && mqMobile;
  const isTablet = isMounted && mqTablet;
  const isDesktop = isMounted && mqDesktop;
  const isLargeDesktop = isMounted && mqLargeDesktop;
  
  return {
    isMobile,
    isTablet,
    isDesktop,
    isLargeDesktop,
    // Helper for touch devices
    isTouchDevice: isMobile || isTablet
  };
}